import { writable } from 'svelte/store';
import { browser } from '$app/environment';
let favorites = [];
if (browser) {
	// @ts-ignore
	favorites = JSON.parse(localStorage.getItem('favorites')) || [];
}

export const favoritesList = writable(favorites || []);
